import React, {useState, useRef, useEffect} from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import APICall from '../../actions/apicall';
import cancelIcon from '../../../images/cancelIcon.png';
import Submit from '../reusable/Submit';
import '../../../css/setpassword.scss';

function SetPasswordSheet(props) {
    const [changePasswordText, setChangePasswordText] = useState('Change Password');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [showError, setShowError] = useState(false);
    const [errorMessageText, setErrorMessageText] = useState('');

    const handleCloseButtonClick = () => {
        props.closeSetPassword();
    }

    const handleSetPassword = () => {
        setChangePasswordText('Submitting...');
        if (newPassword != confirmNewPassword) {
            setErrorMessageText("Your passwords don't match. Please try again.");
            setShowError(true);
            setChangePasswordText('Change Password');
            return
        }
        let data = {
            user_id: props.verifiedData.user.id,
            password: newPassword,
            set_password: true
        }
        
        window.dataLayer.push({'event': 'set_new_password'});

        APICall.SetNewPassword(data, (response) => {
            if (response.status == 200 && response.data.status == 'success') {
                handleCloseButtonClick();
            }
            else {
                setErrorMessageText(response.data.message);
                setShowError(true);
            }
            setChangePasswordText('Change Password');
        });
    }

    useEffect(() => {
        if (props.verifiedData) {
            console.log('Check response', props.verifiedData);
        }
        
    }, [props.verifiedData]);


    return (
        <>
        {
            <BottomSheet open={true} onDismiss={() => handleCloseButtonClick()}
                header={
                    <div className="transparent-header">
                        <img className='cancel-icon' height='25px' src={cancelIcon} onClick={() => handleCloseButtonClick()} />
                    </div>
                }
            >
                <div className='create-password-container'> 
               
                    <div>  
                        <p className='create-text'>Create New Password</p>
                        <hr></hr>
                        <div className='input-container'>
                            <p>Enter your new password.</p>
                            <input 
                                className="password-input" 
                                type="password"
                                id='new-password'
                                value={newPassword}
                                placeholder='New password'
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <input 
                                className="password-input" 
                                type="password"
                                id='new-confirm-password'
                                value={confirmNewPassword}
                                placeholder='Confirm password' 
                                onChange={(e) => setConfirmNewPassword(e.target.value)}
                                onKeyPress={(e) => ((e.key == 'Enter') && handleSetPassword())}
                            />
                            {
                                (showError) && (
                                <p className='create-error'>{errorMessageText}</p>)
                            }
                        </div>
                        {
                            (newPassword.trim().length != 0 && confirmNewPassword.trim().length != 0) ? (
                                <Submit actionText={changePasswordText} callFunction={handleSetPassword} disable={changePasswordText != 'Change Password' && true} />
                            ) : (
                                <Submit actionText={'Change Password'} disable={'button'} />
                            )
                        }
                    </div>
                  
                </div>
            </BottomSheet>
        }
        </> 
    );
}

export default SetPasswordSheet;